import { render, staticRenderFns } from "./VisaSvg.vue?vue&type=template&id=0a9b6830&scoped=true&"
import script from "./VisaSvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VisaSvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b6830",
  null
  
)

export default component.exports